module.exports = __webpack_public_path__ + "static/media/autokar2 (7).a15c73ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar2 (7).jpg
// module id = 854
// module chunks = 0